import React, { Component } from 'react';
import Forms from '../../shared/Forms/Forms';
import {
    MainLogo,
    TiketsPrizeKitCinema,
    TriviaQuestion,
    KitPrizeKitCinema,
    PrizeBookWined,
    PrizeCinemaWined,
    PrizeKitWined
} from '../../constants/assets';
import { map } from 'lodash';
import { sendTrivia } from '../../actions/sendTriviaActions';
import { validEmail } from '../../helpers/index';
import { changeKit, changeTicket } from '../../actions/changePrizes';
import { FaSpinner } from 'react-icons/fa';

class PrizeKitCinema extends Component {
    constructor(props) {
        super(props);
        const { prizeName, playedTimes, profile, idPrize } = props;
        // const socialID = profile && profile.social_id ? profile.social_id : 323423432432;
        const socialID = profile && profile.social_id ? profile.social_id : false;
        this.state = {
            socialID,
            answerSelected: '',
            idPrize,
            isLoading: false,
            isErrorFill: false,
            onStep: 1,
            playedTimes,
            prizeName,
            trivia: props.trivia,
            triviaAnswered: true,
            winner: false,
            formSentOK: false,

            errorFromService: false,
            errorServiceMessage: '',

            formCine: {
                social_id: socialID,
                correo: '',
                telefono: '',
                nombre: ''
            },
            formKit: {
                social_id: socialID,
                nombre: '',
                correo: '',
                celular: '',
                calle: '',
                codigo_postal: '',
                ciudad: '',
                colonia: '',
            }
        };
    }

    componentWillMount() {
        const { socialID } = this.state;
        if(!socialID) {
            // this.props.goToPlaySection();
        }
    }

    goToNext = () => {
        const { answerSelected, onStep, prizeName, idPrize, trivia, triviaAnswered, winner, formCine, formKit } = this.state;
        if(onStep === 2) {
            if(answerSelected !== '') {
                const { profile } = this.props;
                this.setState({ isLoading: true });
                sendTrivia({
                    answerSelected,
                    profile,
                    trivia,
                    endFunction: this.endSendFunction.bind(this),
                    errorFunction: this.errorFunction.bind(this)
                });
            } else {
                alert('Debes seleccionar una respuesta');
            }
        } else if(onStep === 3 && triviaAnswered && !winner) {
            this.props.goToPlaySection();
        } else if(onStep === 4) {
            if(prizeName === 'cine') {
                const {
                    social_id,
                    correo,
                    telefono,
                    nombre
                } = formCine;
                if(social_id !== '' && correo !== '' && telefono !== '' && nombre !== '' && validEmail(correo)) {
                    this.setState({isLoading: true});
                    changeTicket({
                        social_id,
                        correo,
                        telefono,
                        nombre,
                        endFunction: this.formSent.bind(this),
                        errorFunction: this.errorFunction.bind(this)
                    });
                } else {
                    this.setState({isErrorFill: true});
                }
            } else {
                const {
                    social_id,
                    nombre,
                    correo,
                    celular,
                    calle,
                    codigo_postal,
                    ciudad,
                    colonia
                } = formKit;
                if(social_id !== '' && correo !== '' && celular !== '' && nombre !== '' &&
                calle !== '' && codigo_postal !== '' && ciudad !== '' && colonia !== '' && validEmail(correo)) {
                    this.setState({isLoading: true});
                    changeKit({
                        idPrize,
                        social_id,
                        nombre,
                        correo,
                        celular,
                        calle,
                        codigo_postal,
                        ciudad,
                        colonia,
                        endFunction: this.formSent.bind(this),
                        errorFunction: this.errorFunction.bind(this)
                    });
                } else {
                    this.setState({isErrorFill: true});
                }
            }
        } else {
            this.setState({
                onStep: onStep + 1
            });
        }
    }

    errorFunction = (message) => {
        this.setState({
            errorFromService: true,
            errorServiceMessage: message
        });
    };

    endSendFunction = (Data) => {
        const { error } = Data;
        const { onStep } = this.state;

        this.setState({
            isLoading: false,
            onStep: onStep + 1,
            triviaAnswered: true,
            winner: !error
        });
    }

    selectAnswer = (answer) => {
        this.setState({
            answerSelected: answer
        });
    }

    handleChange = (event) => {
        const action = event.target.getAttribute('data-action').split('|');
        if(action[0] === 'formCine') {
            const { formCine } = this.state;
            formCine[action[1]] = event.target.value;
            this.setState({
                formCine,
                isErrorFill: false
            });
        } else {
            const { formKit } = this.state;
            formKit[action[1]] = event.target.value;
            this.setState({
                formKit,
                isErrorFill: false
            });
        }
    }

    formSent = () => {
        this.setState({
            formSentOK: true
        });
    }

    render() {
        const {
            answerSelected,
            formSentOK,
            isErrorFill,
            isLoading,
            onStep,
            playedTimes,
            prizeName,
            trivia,
            winner,
            formCine,
            formKit,
            errorFromService,
            errorServiceMessage
        } = this.state;

        const title = prizeName === 'cine' ? 'Ganaste Boleto Doble de cine' : (
            prizeName === 'kit' ? 'Ganaste kit' : 'Ganaste libro'
        );
        const instructionsText = onStep === 1 ? (
            <p className="instructionsText text-center">
                ¡Felicidades!<br />
                Para llevarte tu premio<br />
                por favor contesta correctamente<br />
                la siguiente trivia:
            </p>
            ) : null;
        const prizeImage = onStep === 1 ? (
            prizeName === 'cine' ? (
                <TiketsPrizeKitCinema />
            ) : (
                <KitPrizeKitCinema />
            )
        ) : null;
        const buttonClass = onStep === 1 || (onStep === 3 && winner) ? 'next-button' : (
            onStep === 2 ? 'square-send-button' : (
                onStep === 4 ? 'send-button' : (
                    onStep === 3 && playedTimes < 5 ?
                    'play-again-button' : ''
                )
            )
        );
        const disabled = isLoading;
        const isLoadingBtn = isLoading ? <FaSpinner /> : '';
        const isLoadingBtnClass = isLoading ? 'loadin-button' : '';
        const errorFillAllMsg = isErrorFill ? (<span className="error-fill">*Todos los campos son obligatorios, y debes escribir un correo electrónico válido.</span>) : null;

        return formSentOK ? (
            <div className={`PrizeKitCinema ${prizeName}`}>
                <h1 className="last-error-message">
                    Tus datos fueron enviados correctamente, pronto nos pondremos en contacto contigo.
                </h1>
                <button className="button prize-kit-button play-again-button" onClick={this.props.goToPlaySection}></button>
            </div>
        ) : (
            <div className={`PrizeKitCinema ${prizeName}`}>
                {!errorFromService && onStep === 1 && (
                    <div>
                        <h1 className="font-sep text-center">{title}</h1>
                        {prizeImage}
                        {instructionsText}
                    </div>
                )}

                {!errorFromService && onStep === 2 && <TriviaQuestion number={parseInt(trivia.id)} />}
                {!errorFromService && onStep === 2 && map(trivia.json_opciones, (value, key) => {
                    const selectedClass = key === answerSelected ? 'selected' : '';
                    return (
                        <button
                            className={`answer-button ${selectedClass}`}
                            disabled={disabled}
                            key={`trivia-answer-${value}-${key}`}
                            onClick={()=>{
                                this.selectAnswer(key);
                            }}
                        >{key}) {value}</button>
                    );
                })}

                {errorFromService && errorServiceMessage !== '' && (
                    <div>
                        <h1 className="last-error-message">{errorServiceMessage}</h1>
                        <button className="button prize-kit-button play-again-button" onClick={this.props.goToPlaySection}></button>
                    </div>
                )}

                {!errorFromService && onStep === 3 && winner && prizeName === 'cine' && <PrizeCinemaWined />}
                {!errorFromService && onStep === 3 && winner && prizeName === 'kit' && <PrizeKitWined />}
                {!errorFromService && onStep === 3 && winner && prizeName === 'book' && <PrizeBookWined />}

                {onStep === 3 && !errorFromService && !winner && playedTimes < 5 && (
                    <h1 className="last-error-message">Respuesta incorrecta<br />Vuelve a intentarlo más tarde.</h1>
                )}
                {onStep === 3 && !errorFromService && !winner && playedTimes >= 5 && (
                    <h1 className="last-error-message">Respuesta incorrecta<br />Regresa mañana para intentarlo de nuevo.</h1>
                )}

                {onStep === 4 && !errorFromService && <Forms
                    formCine={formCine}
                    formKit={formKit}
                    handleChange={this.handleChange.bind(this)}
                    prizeName={prizeName} />}
                {onStep === 4 && errorFillAllMsg}

                {!errorFromService && (
                    <div>
                        <button
                            className={`button prize-kit-button ${buttonClass} ${isLoadingBtnClass}`}
                            disabled={disabled}
                            onClick={this.goToNext}>{isLoadingBtn}</button>
                        <div className="push-to-right">
                            <MainLogo customClass="prize-kit-logo" />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default PrizeKitCinema;
